import React from "react";
import { observer } from "mobx-react";

const Unauthorized = observer((props) => {
  
  const fullHeightStyle = {
    height: "100vh",
  };

  return (
    <>
     <div
        className="d-flex justify-content-center align-items-center"
        style={fullHeightStyle}
        >
          <div className="text-center">
            <div className="col-md p-6">
              <div className="mb-2">
                <img src="../../theme/assets/img/illustrations/page-misc-error.png" alt="page-misc-not-authorized" width="170" className="img-fluid" />
              </div>
              <h4 className="mb-2 mx-2">Unauthorized</h4>
              <p className="mb-6 mx-2">Darn, we could not get you where you were trying to go.</p>
            </div>
          </div>
        </div>
    </>
  );
});

export default Unauthorized;
